import Header from "./Header";
import Footer from "./Footer";
import MobileUrgencyBar from "@/components/MobileUrgencyBar";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function Layout({ children }) {
  const { pathname } = useLocation();

  // Scroll top on route change (unless there's a hash)
  useEffect(() => {
    if (!window.location.hash) {
      window.scrollTo({ top: 0, behavior: "instant" in window.Element.prototype ? "auto" : "auto" });
    }
  }, [pathname]);

  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-orange focus:text-white focus:px-4 focus:py-2 focus:rounded"
        data-testid="skip-to-content"
      >
        Aller au contenu
      </a>
      <Header />
      <main id="main" className="pb-20 lg:pb-0">{children}</main>
      <Footer />
      <MobileUrgencyBar />
    </>
  );
}
